import './participantTitle.scss';

import { useIntl } from 'react-intl';
import classNames from 'classnames';

import { SELECTOR_MODE } from '~constants';
import { getParticipantTitle } from '~helpers';
import { Participant } from '~types/participant';

interface ParticipantTitleProps {
  index: number;
  participant: Participant;
  participantMode: SELECTOR_MODE;
  allParticipants?: Participant[];
  inline?: boolean;
}

const ParticipantTitle = ({
  index: _index,
  participant,
  participantMode,
  allParticipants,
  inline = false,
}: ParticipantTitleProps) => {
  const intl = useIntl();
  const { participantLabel, participantSubLabel } = getParticipantTitle(
    participant,
    intl,
    participantMode,
    allParticipants,
  );

  return (
    <span
      className={classNames('ParticipantTitle', {
        'ParticipantTitle-inline': inline,
      })}
    >
      <span className='ParticipantTitle_name'>{participantLabel}</span>{' '}
      <span className='ParticipantTitle_years'>{participantSubLabel}</span>
    </span>
  );
};

export default ParticipantTitle;
